// src/features/tax/taxApiSlice.js
import { apiSlice } from '../../app/api/apiSlice';

export const taxApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getKurangBayar: builder.query({
      query: ({ customer_id, taxpayer_id, tax_year }) => ({
        url: '/tax/kurang-bayar',
        params: { customer_id, taxpayer_id, tax_year },
      }),
      providesTags: (result, error, arg) => [
        {
          type: 'Tax',
          id: `KURANG_BAYAR-${arg.customer_id}-${arg.taxpayer_id}-${arg.tax_year}`,
        },
      ],
    }),

    getTaxYearSummary: builder.query({
      query: ({ customer_id, taxpayer_id, tax_year }) => ({
        url: '/tax/year-summary',
        params: { customer_id, taxpayer_id, tax_year },
      }),
      providesTags: (result, error, arg) => [
        {
          type: 'Tax',
          id: `YEAR_SUMMARY-${arg.customer_id}-${arg.taxpayer_id}-${arg.tax_year}`,
        },
      ],
    }),

    getPayerSummary: builder.query({
      query: ({ customer_id, taxpayer_id, tax_year, sifat_pemotongan }) => ({
        url: '/tax/payer-summary',
        params: { customer_id, taxpayer_id, tax_year, sifat_pemotongan },
      }),
      providesTags: (result, error, arg) => [
        {
          type: 'Tax',
          id: `PAYER_SUMMARY-${arg.customer_id}-${arg.taxpayer_id}-${arg.tax_year}-${arg.sifat_pemotongan || 'ALL'}`,
        },
      ],
    }),

    simulateTaxScenario: builder.mutation({
      query: ({ customer_id, taxpayer_id, tax_year, tax_profile_scenarios_id }) => ({
        url: '/tax/scenario/simulate',
        method: 'POST',
        body: {
          customer_id,
          taxpayer_id,
          tax_year,
          tax_profile_scenarios_id,
        },
      }),
    }),

    compareTaxScenarios: builder.mutation({
      query: ({ customer_id, taxpayer_id, tax_year, scenario_ids }) => ({
        url: '/tax/scenario/compare',
        method: 'POST',
        body: {
          customer_id,
          taxpayer_id,
          tax_year,
          scenario_ids,
        },
      }),
    }),
  }),
});

export const {
  useGetKurangBayarQuery,
  useGetTaxYearSummaryQuery,
  useGetPayerSummaryQuery,
  useSimulateTaxScenarioMutation,
  useCompareTaxScenariosMutation,
} = taxApiSlice;